import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  influencer: [],
  totalCount: 0,
  influencerDetail: {},

  InfluencerWithdrawList: null,
};

const slice = createSlice({
  name: "influencer",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getInfulencerList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getInfulencerList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      influencer: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getInfulencerList.rejected, (state, action) => ({
      ...state,
      loading: false,
      influencer: [],
      totalCount: 0,
    }));

    // influncer withdraw list
    builder.addCase(
      Act.getInfulencerWithdrawalsList.pending,
      (state, action) => ({
        ...state,
        loading: true,
      }),
    );
    builder.addCase(
      Act.getInfulencerWithdrawalsList.fulfilled,
      (state, { payload }) => {
        state.loading = false;

        state.InfluencerWithdrawList = payload;
        state.totalCount = payload.totalcount;
      },
    );
    builder.addCase(
      Act.getInfulencerWithdrawalsList.rejected,
      (state, action) => ({
        ...state,
        loading: false,
        InfluencerWithdrawList: null,
        totalCount: 0,
      }),
    );

    // //add category
    builder.addCase(Act.editUserStatus.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(Act.editUserStatus.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.editUserStatus.rejected, (state, action) => ({
      ...state,
      loading: false,
      influencerDetail: {},
    }));
    builder.addCase(Act.getInfluencerDetail.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.getInfluencerDetail.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        influencerDetail: payload.data,
      }),
    );
    builder.addCase(Act.getInfluencerDetail.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.updateInfluencerRequest.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.updateInfluencerRequest.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
      }),
    );
    builder.addCase(Act.updateInfluencerRequest.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
  },
});

export default slice;
